import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DeeplinksService {
  deeplink$: BehaviorSubject<string>;
  marketAdminUrl$: BehaviorSubject<string>;
  registrationAdminUrl$: BehaviorSubject<string>;

  constructor(private apiService: ApiService) {
    this.deeplink$ = new BehaviorSubject<string>('');
    this.marketAdminUrl$ = new BehaviorSubject<string>('');
    this.registrationAdminUrl$ = new BehaviorSubject<string>('');
  }

  async setMarketAdminUrl() {
    try {
      const url = await this.apiService.get('deeplinks/markets/');
      this.deeplink$.next(url + '/create');
    } catch (err) {
      console.log('Could not load market admin url.', err);
    }
  }

  async setRegistrationAdminUrl() {
    try {
      const url = await this.apiService.get('deeplinks/registrations/');
      this.deeplink$.next(url);
    } catch (err) {
      console.log('Could not load registration url.', err);
    }
  }

  async getMarketAdminUrl(): Promise<string> {
    try {
      const url = await this.apiService.get('deeplinks/markets/');
      this.marketAdminUrl$.next(url);
      return url;
    } catch (err) {
      console.log('Could not load market admin url.', err);
      return '';
    }
  }

  async getRegistrationAdminUrl(): Promise<string> {
    try {
      const url = await this.apiService.get('deeplinks/registrations/');
      this.registrationAdminUrl$.next(url);
      return url;
    } catch (err) {
      console.log('Could not load registration admin url.', err);
      return '';
    }
  }
}
